var map = {
	"./about-us_small.jpg": 58,
	"./ben-mullins-5QTQz-oYk1A_small.jpg": 59,
	"./czytanie-a-czytanie_small.jpg": 60,
	"./guillaume-de-germain-fgmLRBlUIpc_small.jpg": 61,
	"./kelly-sikkema-4JxV3Gs42Ks_small.jpg": 62,
	"./nie-czas-na-nude_small.jpg": 63,
	"./to-nie-tylko-bajki_small.jpg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 122;